import React, { useEffect, useState } from "react";
import "./checkoutform.scss"
import {
  PaymentElement,
  LinkAuthenticationElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import { config } from '../../../config';
import StatusContext from '../../../contexts/StatusContext'

const CheckoutForm = ({ value }) => {
  const stripe = useStripe();
  const elements = useElements();
  // eslint-disable-next-line
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const {
    changeLanguage,
} = React.useContext(StatusContext);

  
  useEffect(() => {
    if (!stripe) {
      return;
    }

    console.log("CheckoutForm - buyteststatus:",sessionStorage.getItem('buyteststatus'))

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("HandleSubmit")
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    let paymentstatus = {
      message: `Thank you. Payment of ${value} has been sucessful.`,
      display: true
    }
    

    //sessionStorage.setItem("PaymentStatus", JSON.stringify(paymentstatus))

    var page = '';
    console.log("CheckoutForms handleSubmit: status", sessionStorage.getItem('buyteststatus'))

    let buytest = JSON.parse(sessionStorage.getItem('buyteststatus'))
    console.log("CheckoutForm - buyteststatus", buytest)
    if (buytest && buytest.status === true)
    {
      page =  `/buytestsuccess`
      //page = `/aitest`
    }
    else 
    {
      let purchase = JSON.parse(sessionStorage.getItem('PurchaseType'))
   
      if (purchase.type === 'Credits')
      { 
        console.log("CreditsPurchaseSuccess")
        page =  `/home/${"CreditsPurchaseSuccess"}`
      }
      else if ( purchase.type === 'MyTestPurchase')
      { 
        console.log("MyTestPurchaseSussess")
        page =  `/aitest/${"MyTestPurchaseSuccess"}`
      }
      else
      {
        console.log("InvalidPurchaseType")
        page =  `/home/${"InvalidPurchaseType"}`
      }
    }
  
      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          // Make sure to change this to your payment completion page
          return_url: config.url.DOMAIN_URL + page,
        },
      });



    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    //sessionStorage.setItem('buyteststatus', false)

    paymentstatus = {
      message: `Your payment of $` + value + ` has NOT been completed.`,
      display: true
    }

    sessionStorage.setItem("PaymentStatus", JSON.stringify(paymentstatus))
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs"
  }

  return (

    <form id="payment-form" onSubmit={handleSubmit}>
      <LinkAuthenticationElement
        id="link-authentication-element"
      
      />
      <PaymentElement id="payment-element" options={paymentElementOptions} />
        {/* Show any error or success messages */}
        {message && <div id="payment-message">{message}</div>}
      <button disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : `${changeLanguage('credits', 'paynow')} $${value}`}
        </span>
      </button>
    
    </form>

  )
}

export default CheckoutForm
